import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { translateText } from './utils/functions';
import PaginationButton from './_PaginationButton';

class Pagination extends React.Component {
  constructor() {
    super();
    this.moduleName = 'pagination';
    this.goToPageNumber = this.goToPageNumber.bind(this);
  }

  goToPageNumber(targetPageNumber) {
    const { goToPageNumber } = this.props;
    goToPageNumber(targetPageNumber);
  }

  render() {
    const {
      props,
      moduleName,
      goToPageNumber
    } = this;

    const {
      languageCode = 'en',
      pageNumber,
      rowsPerPage,
      rowCount,
      columnCount,
      refParentTable
    } = props;

    const sharedButtonClasses = ['button', 'button-primary', 'flex-shrink-0'];
    const sharedButtonAttributes = { refParentTable };

    return (
      <tr>
        <td colSpan={columnCount}>
          <nav className='table-pagination'>
            <PaginationButton
              {...sharedButtonAttributes}
              goToPageNumber={() => goToPageNumber(pageNumber - 1)}
              classNames={[...sharedButtonClasses, 'button-paging-prev']}
              isDisabled={pageNumber < 2}
              title={translateText(
                moduleName,
                'button-prev-title',
                languageCode,
                { rowsPerPage }
              )}
              buttonContent={(
                <React.Fragment>
                  <FontAwesomeIcon icon='chevron-left' className='itemgap-right' />
                  {translateText(moduleName, 'button-prev-label', languageCode)}
                </React.Fragment>
              )}
            />

            <p>{translateText(moduleName, 'text-actual-page', languageCode, { pageNumber })}</p>

            <PaginationButton
              {...sharedButtonAttributes}
              goToPageNumber={() => goToPageNumber(pageNumber + 1)}
              classNames={[...sharedButtonClasses, 'button-paging-next']}
              isDisabled={rowsPerPage > rowCount}
              title={translateText(moduleName, 'button-next-title', languageCode, { rowsPerPage })}
              buttonContent={(
                <React.Fragment>
                  {translateText(moduleName, 'button-next-label', languageCode)}
                  <FontAwesomeIcon icon='chevron-right' className='itemgap-left' />
                </React.Fragment>
              )}
            />
          </nav>
        </td>
      </tr>
    );
  }
}

export default Pagination;